import { cnTwMerge } from "../../utils/cnTwMerge";

import { ThemedButton, type ThemedButtonProps } from "./ThemedButton";

/**
 * A themed button with the tertiary variant, which is a green text interactive button.
 *
 * @example <ThemedButton variant="tertiary">
 *
 **/
export const InteractiveButton = ({
  className,
  ...props
}: ThemedButtonProps) => (
  <ThemedButton
    className={cnTwMerge(
      "text-text/interactive rich-link h-min p-0",
      className,
    )}
    variant="tertiary"
    {...props}
  />
);
